/**
 * 익명 세션 식별자 — 같은 사람이 연달아 올린 문제를 회원 없이 묶는 값(설계서 D-03).
 *
 * **개인을 식별하는 값이 아니고, 그 상태를 유지한다.** 브라우저가 만든 난수이며
 * 서버는 IP·UA에서 이 값을 파생하지 않는다(002 마이그레이션 주석).
 *
 * `sessionStorage`에 두는 이유는 탭을 닫으면 사라지게 하기 위해서다 —
 * `localStorage`에 두면 기기에 영구히 남아 사실상 추적 식별자가 된다.
 */

const KEY = 'haebom.sessionId'

/**
 * 저장된 값이 있으면 그대로, 없으면 새로 만들어 돌려준다.
 * 저장소를 못 쓰는 환경(프라이빗 모드·차단)에서는 `undefined`를 돌려주고 접수는 그대로 진행한다 —
 * 세션 묶기는 부가 정보라 이것 때문에 시민이 등록을 못 하면 안 된다.
 */
export function getSessionId(): string | undefined {
  try {
    const existing = sessionStorage.getItem(KEY)
    if (existing !== null && existing !== '') return existing
    // API의 형식 제한(영숫자·하이픈·밑줄 8~64자)에 맞춰 하이픈을 뺀 32자로 만든다.
    const id = crypto.randomUUID().replace(/-/g, '')
    sessionStorage.setItem(KEY, id)
    return id
  } catch {
    return undefined
  }
}
